// src/components/elements/SidebarToggle.js
import React from 'react';
import useAppStore from '../../contexts/useAppStore';
import IconEffectWrapper from './IconEffectWrapper';

const SidebarToggle = () => {
  const toggleSidebar = useAppStore((state) => state.toggleSidebar);

  return (
    <IconEffectWrapper onClick={toggleSidebar}>
      <i className="bi bi-layout-sidebar text-base"></i>
    </IconEffectWrapper>
  );
};

export default SidebarToggle;
